import { Component, forwardRef } from '@angular/core';
import { ContextService } from '../../../shared/services/context.service';
import { TranslateModule } from '@ngx-translate/core';
import { ParkourBackButtonDirective } from '../../../shared/directives/parkour-back-button.directive';
import { AsyncPipe } from '@angular/common';
import { PageLayoutComponent } from '../../../shared/components/page-layout/page-layout.component';
import { ProfielDetailsComponent } from '../../../profiel/component/profile-details/profiel-details.component';
import { getProfielnaam } from '../../../profiel/model/profiel-in-team';
import { ParkourDataPage } from '../../../shared/parkour-data-page';
import { TeamlidContext } from '../../../shared/model/context';
import { Observable } from 'rxjs';
import { PageContentDirective } from '../../../shared/directives/page-content.directive';
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonRefresher,
  IonRefresherContent,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { ParkourRefreshDirective } from '../../../shared/directives/parkour-refresh-directive';
import { ProfielDetailsAfwezigheidCardComponent } from '../../../profiel/component/profiel-details-afwezigheid-card/profiel-details-afwezigheid-card.component';

@Component({
  standalone: true,
  templateUrl: './team-owner-details.page.html',
  imports: [
    ParkourBackButtonDirective,
    PageLayoutComponent,
    AsyncPipe,
    TranslateModule,
    ProfielDetailsComponent,
    forwardRef(() => PageContentDirective),
    IonRefresher,
    IonRefresherContent,
    IonBackButton,
    ParkourRefreshDirective,
    IonContent,
    IonTitle,
    IonButtons,
    IonToolbar,
    IonHeader,
    ProfielDetailsAfwezigheidCardComponent,
  ],
})
export class TeamOwnerDetailsPage extends ParkourDataPage<TeamlidContext> {
  constructor(private readonly contextService: ContextService) {
    super();
  }

  override retrieveMainData(): Observable<TeamlidContext> {
    return this.contextService.teamlidContext$();
  }

  getCustomPageTitle() {
    return this.generateDefaultTitle(
      (data) => getProfielnaam(data.jongereProfiel),
      'team.teamowner-details-page.title',
      true,
    );
  }
}
